import React, { useEffect, useContext } from 'react';
import { CircularProgress, Backdrop } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { QuestionnaireContext } from "../../../store/questionnaire-context";


export default function PaymentSuccess() {

  // useEffect(() => {
  //   const successData = { status: "success" };
  //   alert(window.parent.location);

  //   window.parent.postMessage(successData, "*");
  // }, []);

  useEffect(() => {
    const queryString = window.parent.location.search;
    const urlParams = new URLSearchParams(queryString);
    const SectionId = urlParams?.get('SectionId');
    const PQID = urlParams?.get('pqId');
    window.top.location.href = "/vendordetails?pqid=" + PQID + "&sectionid=" + SectionId
  }, []);

  // const navigate = useNavigate();
  // const questionnaireStore = useContext(QuestionnaireContext);
  //   useEffect(() => {      
  //      const pqId =  questionnaireStore?.currentPqId;
  //      setTimeout(() => {
  //        // Navigate to the vendorDetails page after the delay
  //        if (+pqId > 0) {
  //          navigate(`/vendorDetails?pqid=${pqId}&tab=Questionnaire`);
  //        } else {
  //          console.error(questionnaireStore);
  //        }
  //      }, 500);
  //   }, [questionnaireStore?.currentPqId]);


  //  const navigate = useNavigate();
  // useEffect(() => {
  //   navigate(-1);
  // }, []);

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop></div>
  )
}
